import * as m from "@/paraglide/messages";

export const authErrors: any = {
  // auth
  "auth/email-already-in-use": m.email_in_use(),
  "auth/invalid-credential": m.wrong_cred(),
  "auth/user-not-found": m.no_user(),
  "auth/weak-password": m.week_password(),
  "auth/popup-closed-by-user": m.cancelled_auth(),
  "auth/wrong-password": m.invalid_email(),
  "auth/wrong-password-update": m.invalid_old_password(),
  "auth/too-many-requests": m.blocked_auth(),
  "auth/invalid-email": m.invalid_email_address(),
  "auth/operation-not-allowed": m.provider_not_supported(),
  "auth/user-disabled": m.disabled_account(),
  "auth/account-exists-with-different-credential": m.inner_noisy_skate_fear(),
  "auth/expired-action-code": m.tense_icy_goldfish_express(),
  "auth/invalid-action-code": m.moving_loved_osprey_dash(),
  "auth/invalid-verification-code": m.few_active_jackdaw_bump(),
  "auth/invalid-verification-id": m.plane_extra_zebra_fold(),
  "auth/missing-verification-code": m.best_noble_squirrel_hug(),
  "auth/missing-verification-id": m.loose_busy_fox_fear(),
  "auth/credential-already-in-use": m.brave_stout_kudu_shine(),
  "auth/user-mismatch": m.wild_jolly_clownfish_play(),
  "auth/requires-recent-login": m.solid_topical_swallow_intend(),
  "auth/provider-already-linked": m.tiny_ornate_vulture_pray(),
  "auth/no-such-provider": m.extra_warm_crossbill_peel(),
  "auth/invalid-user-token": m.free_solid_chipmunk_imagine(),
  "auth/user-token-expired": m.bad_level_hedgehog_pet(),
  "auth/network-request-failed": m.tangy_lime_lamb_work(),
  "auth/timeout": m.flat_suave_flamingo_honor(),
  "auth/invalid-api-key": m.helpful_fresh_bumblebee_spur(),
  "auth/app-deleted": m.ago_alive_ibex_trust(),
  "auth/internal-error": m.fit_level_dingo_emerge(),
  "auth/unauthorized-domain": m.minor_deft_dingo_borrow(),
  "auth/invalid-tenant-id": m.same_livid_coyote_bump(),
  "auth/tenant-id-mismatch": m.simple_actual_frog_blink(),
  "auth/missing-android-pkg-name": m.vivid_clear_warthog_vent(),
  "auth/missing-continue-uri": m.that_fit_tuna_fulfill(),
  "auth/missing-ios-bundle-id": m.moving_fuzzy_insect_intend(),
  "auth/invalid-continue-uri": m.deft_level_kangaroo_roam(),
  "auth/unauthorized-continue-uri": m.sharp_green_shad_accept(),
  "auth/captcha-check-failed": m.sleek_witty_lemur_peel(),
  "auth/missing-captcha-token": m.slow_true_crocodile_quell(),
  "auth/invalid-captcha-token": m.weary_nimble_impala_boil(),
  "auth/admin-restricted-operation": m.knotty_spicy_kestrel_enchant(),
  "auth/maximum-user-count-exceeded": m.left_just_jackdaw_splash(),
  "auth/multi-factor-auth-required": m.crisp_light_midge_lock(),
  "auth/unsupported-first-factor": m.mellow_grand_orangutan_imagine(),
  "auth/unsupported-second-factor": m.close_few_dolphin_value(),
  "auth/email-change-needs-verification": m.such_weird_leopard_roam(),
  "auth/unverified-email": m.real_broad_ape_conquer(),
  "auth/phone-number-already-exists": m.round_cozy_rabbit_pet(),
  "auth/project-not-found": m.cute_level_hound_comfort(),
};

export const authErrorHandler = (error: any, path?: string) => {
  if (path === "updatePassword") {
    return (
      authErrors["auth/wrong-password-update"] ||
      error.message ||
      m.something_went_wrong()
    );
  }
  return authErrors[error.code] || error.message || m.something_went_wrong();
};
